var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from "react";
import ViewSupplierView from "../presentation/view-supplier";
import axios from "axios";
import moment from "moment";
import CONSTS from "../consts";
export default class ViewSuppliers extends React.Component {
    constructor(props) {
        super(props);
        this.getSupplier = () => {
            let oDataPath = CONSTS.APIURL;
            let query = `${oDataPath}Suppliers/ConnectMobile.Web.GetByNumber(number=${this.props.id})`;
            axios
                .get(query)
                .then(response => {
                let supplier = {};
                for (let atr in response.data) {
                    supplier[atr] =
                        typeof response.data[atr] === "string"
                            ? response.data[atr].toLowerCase().trim()
                            : response.data[atr];
                }
                this.setState({
                    supplier
                }, () => {
                    this.getSupplierServices();
                    this.getFeaturedProducts();
                    this.getStoreEvents();
                });
            });
        };
        this.state = {
            supplier: {},
            featuredProducts: {},
            inpageNav: [],
            storeEvents: [],
            supplierServices: {}
        };
    }
    getSupplierServices() {
        let supplier = this.state.supplier;
        let services = {};
        if (supplier.LicenseeSales) {
            services.LicenseeSales = supplier.LicenseeSales;
        }
        if (supplier.SpecialEventsOrdering) {
            services.SpecialEventsOrdering = supplier.SpecialEventsOrdering;
        }
        if (supplier.OnSiteSpecialEvents) {
            services.OnSiteSpecialEvents = supplier.OnSiteSpecialEvents;
        }
        if (supplier.OnSiteKitchen) {
            services.OnSiteKitchen = supplier.OnSiteKitchen;
        }
        if (supplier.KegSales) {
            services.KegSales = supplier.KegSales;
        }
        if (supplier.SommelierOnStaff) {
            services.SommelierOnStaff = supplier.SommelierOnStaff;
        }
        if (supplier.OnlineOrdering) {
            services.OnlineOrdering = supplier.OnlineOrdering;
        }
        if (supplier.SpecialOrdering) {
            services.SpecialOrdering = supplier.SpecialOrdering;
        }
        if (supplier.DeliveryService) {
            services.DeliveryService = supplier.DeliveryService;
        }
        if (supplier.GrowlerFill) {
            services.GrowlerFill = supplier.GrowlerFill;
        }
        this.setState((prevState, props) => (Object.assign(Object.assign({}, prevState), { supplierServices: services, inpageNav: Object.keys(services).length !== 0
                ? [...prevState.inpageNav, "services"]
                : prevState.inpageNav })));
    }
    getStoreEvents() {
        return __awaiter(this, void 0, void 0, function* () {
            let supplier = this.state.supplier;
            let date = new Date(), y = date.getFullYear(), m = date.getMonth();
            let firstDay = new Date(y, m, 1);
            let lastDay = new Date(y, m + 1, 0);
            let supplierId = supplier.Id;
            let oDataPath = CONSTS.APIURL;
            let query = `${oDataPath}Events?` +
                `$orderby=StartDate&` +
                `$filter=LicenseeId eq ${supplierId} and StartDate ge ${moment().format("YYYY-MM-DD")}T00:00:00.000Z&$expand=RelatedProducts`;
            const StoreEventsPromise = yield axios.get(query);
            this.setState((prevState, props) => (Object.assign(Object.assign({}, prevState), { storeEvents: StoreEventsPromise.data.value, inpageNav: [...prevState.inpageNav, "events"] })));
        });
    }
    getFeaturedProducts() {
        return __awaiter(this, void 0, void 0, function* () {
            let supplier = this.state.supplier;
            let supplierId = supplier.Id;
            let oDataPath = CONSTS.APIURL;
            let query = `${oDataPath}FeaturedProducts?` +
                `$filter=LicenseeId eq ${supplierId}` +
                `&$expand=Product`;
            const featuredProductsPromise = yield axios.get(query);
            this.setState((prevState, props) => (Object.assign(Object.assign({}, prevState), { featuredProducts: featuredProductsPromise.data.value, inpageNav: featuredProductsPromise.data.value.length > 0 ? [...prevState.inpageNav, "products"] : [...prevState.inpageNav] })));
        });
    }
    componentDidMount() {
        this.getSupplier();
    }
    render() {
        return React.createElement(ViewSupplierView, Object.assign({}, this.state));
    }
}
//# sourceMappingURL=view-supplier.js.map